import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useTypedDispatch } from '../../stores';
import { setUser } from '../../stores/user';
import { clearLocalStorage } from '../../utils/storage';
import { initialUser } from '../../utils/user';

export default function useLogout() {
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();

  return useCallback(() => {
    dispatch(setUser(initialUser));
    clearLocalStorage();
    navigate('/login');
  }, [dispatch, navigate]);
}
